import { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext({ lang: "ro", setLang: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("gd_lang") || "ro");
  useEffect(() => {
    localStorage.setItem("gd_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return <LanguageContext.Provider value={{ lang, setLang }}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);

export const LangSwitch = ({ className = "" }) => {
  const { lang, setLang } = useLang();
  return (
    <div className={`inline-flex items-center rounded-full border border-white/20 overflow-hidden text-[11px] font-accent tracking-[0.15em] ${className}`} data-testid="lang-switch">
      {["ro", "en"].map((l) => (
        <button
          key={l}
          data-testid={`lang-${l}`}
          onClick={() => setLang(l)}
          className={`px-3 py-1.5 uppercase transition-colors duration-300 ${lang === l ? "bg-gold text-ink" : "text-white/60 hover:text-white"}`}
        >
          {l}
        </button>
      ))}
    </div>
  );
};
